export class TimeLineComponent {
    constructor(containerTimeLineId) {
        this.containerTimeLineId = containerTimeLineId;
        this.removeSelectedClass = () => {
            const containerTimeLine = document.getElementById(this.containerTimeLineId);
            if (!containerTimeLine)
                return;
            Array.from(containerTimeLine.children).forEach((timeLineItem) => {
                timeLineItem.classList.remove('item-selected');
            });
        };
        this.horizontalScroll = (containerTimeLine) => {
            containerTimeLine.addEventListener("wheel", (evt) => {
                evt.preventDefault();
                containerTimeLine.scrollLeft += evt.deltaY;
            }, { pasive: true });
        };
        this.centerContent = (timeLineItem) => {
            let yearContainer = timeLineItem.querySelector('.timelineYear');
            // let logoContainer:any = timeLineItem.querySelector('.timelineLogo');
            yearContainer && (yearContainer.style.marginLeft = `-${yearContainer.offsetWidth / 2}px`);
            // logoContainer && (logoContainer.style.marginLeft = `-${logoContainer.offsetWidth/2}px`);
        };
        console.log("Iniciando TimeLine component !!!");
    }
    onInit() {
        const containerTimeLine = document.getElementById(this.containerTimeLineId);
        if (!containerTimeLine)
            return console.log("Not container with id : ", this.containerTimeLineId);
        Array.from(containerTimeLine.children).forEach((timeLineItem, index) => {
            var _a;
            let dataYear = timeLineItem.getAttribute('data-year');
            let dataLogoSrc = timeLineItem.getAttribute('data-logo-src');
            let dataLines = parseInt(timeLineItem.getAttribute('data-lines') || '10');
            let internalContent = `<div class="flex flex-col">` +
                `<span class="timelineYear text-white w-max">${dataYear}</span>` +
                `<div class="flex my-4">` +
                `<span class="lg-line"></span>`;
            if (index < containerTimeLine.children.length - 1) {
                for (let i = 0; i < dataLines; i++) {
                    internalContent = internalContent + `<span class="sm-line"></span>`;
                }
            }
            else {
                timeLineItem.classList.add('item-selected');
            }
            internalContent = internalContent + `</div>` +
                `<picture class="timelineLogo w-10 -ml-5">` +
                `<img src="${dataLogoSrc}" loading="lazy" class="w-full alt="${dataYear}">` +
                `</picture>` +
                `</div>`;
            timeLineItem.innerHTML = internalContent;
            this.centerContent(timeLineItem);
            (_a = timeLineItem.querySelector('img')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', () => {
                this.removeSelectedClass();
                timeLineItem.classList.add('item-selected');
            });
        });
        this.horizontalScroll(containerTimeLine);
    }
}
